// extracted by mini-css-extract-plugin
export default {"emailStudioContainer":"Ts7ZZEAmjL0xz5O0fk83","emailStudioItem":"tbVh82RUIP5DFng7j21C","previewContainer":"E1EYKwiqnSVIfqYPzNCk","imgWrap":"msdqbEl37kLTfDSpblid"};